import React from 'react'
import fieldTypes from './field-content'
import {isFieldEmpty} from '../../helpers/utils'

export default function Field (props) {
  const { id, name, className, context } = props

  const sections = props.sections
    .map((props, contentId) => ({props, Element: fieldTypes[props.type], contentId}))
    .filter(({Element, props}) => Element && !isFieldEmpty(props))
    .map(({Element, props, contentId}, index) => (<Element key={index} {...props} id={id} contentId={contentId} context={context} />))

  return (<React.Fragment>
    {sections.length > 0 && (<React.Fragment>
    <div className={`${className} field-title title`}>
      {name}
    </div>
    <div className="field-wrapper">
      <div id={id} className={`${className} field`}>
        <div className="content">
          {sections}
        </div>
      </div>
    </div>
    </React.Fragment>)}
  </React.Fragment>)
}

